module.exports = __webpack_public_path__ + "img/kr-product-agency-card4-5.8ad9867.png";